export default __webpack_public_path__ + "static/icon-15-1-8d7ff4247cf741f4b64a2849c3235869.png";